import React, { Component } from 'react'
import { Button, Dropdown, Icon, Input, Popup } from 'semantic-ui-react'
import DateRangePicker from 'react-daterange-picker'
import Moment from 'moment'
import { extendMoment } from "moment-range"
import { translate } from 'react-i18next'
import qs from 'query-string'
import "./TimeRangeFilter.css"
import { getUpdatedDate } from 'helpers/constants_helper'

const moment = extendMoment(Moment); // extends moment as a part of moment-range

const MIN_DATE = moment()
  .subtract(1,"years")
  .toDate();
const MAX_DATE = moment()
  .add(1,"days")
  .toDate();

class FilterBar extends Component {

  constructor(props) {
    super(props);
    
    if (this.props.location.search) {
      this.params = qs.parse(this.props.location.search);
    }

    this.pushProps = this.pushProps.bind(this);
    this.twiddleDate = this.twiddleDate.bind(this);
    this.dateSelection = this.dateSelection.bind(this);
    this.getCalendarDateRange = this.getCalendarDateRange.bind(this);

    this.state = {
      isCalendarOpen: false
    }
  }

  input = {};
  params = {};

  pushProps() {
    let newParams = qs.parse(this.props.location.search);
    let found = false;
    const input = this.input
    const params = this.params
    Object.keys(input).forEach( key => {
      let value = ""
      if (input[key].inputRef && input[key].inputRef.current) {
        value = input[key].inputRef.current.value;
      } else if (input[key].state) {
        value = input[key].state.value;
      }
      if (value.trim() !== "") {
        newParams[key] = value;
        if (newParams[key] !== params[key]) {
          found = true;
        }
      } else {
        if (newParams[key]) {
          delete newParams[key];
          if (newParams[key] !== params[key]) {
            found = true;
          }
        }
      }
    });
    if (found) {
      let myUrl = this.props.location.pathname.replace(this.props.location.search,'');
      this.props.history.push(myUrl + "?" + qs.stringify(newParams));
    }
  }

  dateSelection(dates) {
    let startMoment = moment.utc(dates.start).startOf("day");
    let endMoment = moment.utc(dates.end).endOf("day");

    this.input.startOnAfter.inputRef.current.value = startMoment.toISOString();
    this.input.startBefore.inputRef.current.value = endMoment.toISOString();
    this.setState({isCalendarOpen: false});
  }

  paginationArrow = properties => {
    let iconName, opacity, left, right;
    if (properties.direction === "previous") {
      iconName = "arrow left";
      left = 20;
    } else {
      iconName = "arrow right";
      right = 20;
    }

    opacity = properties.disabled ? 0.5 : 1;

    const iconStyle = {
      opacity: opacity,
      left: left,
      right: right                              
    };                                          
    return (                                    
      <Icon                                     
        size="large"                            
        className="paginator"                   
        onClick={properties.onTrigger}          
        name={iconName}                         
        style={iconStyle}                       
      />                                        
    );                                          
  };         

  getCalendarDateRange() {
    let startMoment,endMoment;

    if (this.input.startOnAfter) {
      let ms = Date.parse(this.input.startOnAfter.inputRef.current.value);
      if (!isNaN(ms) && ms > 0) {
        startMoment = moment.utc(ms);
      } 
    }
    if (!startMoment && this.params.startOnAfter) {
      startMoment = moment(this.params.startOnAfter);
    }
    if (!startMoment) {
      if (this.params.timePeriod) {
        startMoment = moment.utc(getUpdatedDate(this.params.timePeriod));
      } else {
        startMoment = moment.utc(getUpdatedDate("WEEK"));
      }
    }

    if (this.input.startBefore) {
      let ms = Date.parse(this.input.startBefore.inputRef.current.value);
      if (!isNaN(ms) && ms > 0) {
        endMoment = moment.utc(ms);
      } 
    }
    if (!endMoment && this.params.startBefore) {
      endMoment = moment(this.params.startBefore);
    }
    if (!endMoment) {
      endMoment = moment.utc();
    }

    return moment.range(startMoment,endMoment);
  }

  twiddleDate(item) {
    let ms = Date.parse(item.inputRef.current.value);
    if (!isNaN(ms) && ms > 0) {
      item.inputRef.current.value = new Date(ms).toISOString();
    } else {
      item.inputRef.current.value = null;
    }
  }

  render() {
    const { t } = this.props;
    if (this.props.filterHidden) {
      return null;
    }
    return (
      <div>
        <div>
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.From")} 
            ref={ref => this.input.from = ref} icon={<Icon name="asterisk"/>}
            defaultValue={this.params.from}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.DialNumber")}
            ref={ref => this.input.dialNumber = ref}
            defaultValue={this.params.dialNumber}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.DialString")}
            ref={ref => this.input.dialString = ref}
            defaultValue={this.params.dialString}
          />
          <Input
            placeholder={t("Screens.Calls.List.FilterBar.ConferenceId")}
            ref={ref => this.input.conferenceId = ref}
            defaultValue={this.params.conferenceId}
          />
        </div>
        <div>
          <Popup
            trigger={
              <Button 
                icon 
                labelPosition="right"
                style={{
                  textAlign: "left"
                }}
              >
                Date Selector
                <Icon name="dropdown" />
              </Button>
            }
            content={
              <DateRangePicker
                numberOfCalendars={1}
                minimumDate={MIN_DATE}
                maximumDate={MAX_DATE}
                onSelect={this.dateSelection}
                value={this.getCalendarDateRange()}
                paginationArrowComponent={this.paginationArrow}
              />
            }
            flowing
            on="click"
            position="bottom center"
            value={this.getCalendarDateRange()}
            open={this.state.isCalendarOpen}
            onClose={() => this.setState({isCalendarOpen: false})}
            onOpen={() => this.setState({isCalendarOpen: true})}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.StartAfter")} 
            style={{width:"20em"}} 
            ref={ref => this.input.startOnAfter = ref}
            defaultValue={this.params.startOnAfter}
            onBlur={() => this.twiddleDate(this.input.startOnAfter)}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.StartBefore")}
            style={{width:"20em"}} 
            ref={ref => this.input.startBefore = ref}
            defaultValue={this.params.startBefore}
            onBlur={() => this.twiddleDate(this.input.startBefore)}
          />
        </div>
        <div>
          <Input
            placeholder={t("Screens.Calls.List.FilterBar.ShorterThan")}
            ref={ref => this.input.shorterThan = ref}
            defaultValue={this.params.shorterThan}
          />
          <Input
            placeholder={t("Screens.Calls.List.FilterBar.LongerThan")}
            ref={ref => this.input.longerThan = ref}
            defaultValue={this.params.longerThan}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.EndReason")}
            ref={ref => this.input.endReason = ref} 
            icon={<Icon name="asterisk"/>}
            defaultValue={this.params.endReason}
          />
          <Input 
            placeholder={t("Screens.Calls.List.FilterBar.Region")}
            ref={ref => this.input.region = ref}
            defaultValue={this.params.region}
          />
          <Dropdown 
            placeholder={t("Screens.Calls.List.FilterBar.Protocol")}
            selection 
            options={[ 
              {text:t("Screens.Calls.List.FilterBar.Protocol"), value: ""}, 
              {text:"H323", value:"H323"}, 
              {text:"SIP", value:"SIP"} 
            ]} 
            style={{minWidth:"5em"}} 
            ref={ref => this.input.protocol = ref}
            defaultValue={this.params.protocol}
          />
          <Dropdown 
            placeholder={t("Screens.Calls.List.FilterBar.LicenseUse")}
            selection 
            options={[ 
              {text:t("Screens.Calls.List.FilterBar.Licensed"), value: ""},
              {text:t("Screens.Calls.List.FilterBar.Surge"), value: "allowed"},
              {text:t("Screens.Calls.List.FilterBar.Rejected"), value: "rejected"},
              {text:t("Screens.Calls.List.FilterBar.Overages"), value: "all"}
            ]} 
            style={{minWidth:"5em"}} 
            ref={ref => this.input.exceedLicenseCapacity = ref}
            defaultValue={this.params.exceededLicenseCapacity}
          />
        </div>
        <div>
          <Button title={t("Screens.Calls.List.FilterBar.Apply")}
            onClick={() => {
              this.pushProps();
            }}
          >
            <Icon name="search" />
            Apply Filter
          </Button>
          (<Icon name="asterisk"/> {t("Screens.Calls.List.FilterBar.Asterisk")})
        </div>
      </div>
    );
  }
}

export default translate()(FilterBar);
